// fillBuckets expands the summary's sparse series (non-empty UTC buckets only) into a
// continuous ascending series covering every bucket in [from, to], inserting zero buckets
// where the backend omitted a quiet one. Granularity "minute" steps by the minute; anything
// else steps by the hour. The bucket timestamp lives under the `hour` key at both
// granularities (the backend reuses that JSON field). Pure.

const HOUR_MS = 3600_000;
const MINUTE_MS = 60_000;

function stepMs(granularity) {
  return granularity === "minute" ? MINUTE_MS : HOUR_MS;
}

function trunc(ms, step) {
  return Math.floor(ms / step) * step;
}

export function fillBuckets(series, from, to, granularity) {
  const step = stepMs(granularity);
  const fromMs = Date.parse(from);
  const toMs = Date.parse(to);
  if (Number.isNaN(fromMs) || Number.isNaN(toMs) || toMs < fromMs) return [];

  const byBucket = new Map();
  for (const b of series || []) {
    const t = Date.parse(b.hour);
    if (!Number.isNaN(t)) byBucket.set(trunc(t, step), b);
  }

  const out = [];
  const start = trunc(fromMs, step);
  const end = trunc(toMs, step);
  for (let t = start; t <= end; t += step) {
    const b = byBucket.get(t);
    const hour = new Date(t).toISOString();
    out.push(
      b
        ? { hour, events: b.events, cost: b.cost, tokens: b.tokens }
        : { hour, events: 0, cost: 0, tokens: 0 }
    );
  }
  return out;
}

// fillHours fills the series at hourly granularity (back-compat wrapper around fillBuckets).
export function fillHours(hourly, from, to) {
  return fillBuckets(hourly, from, to, "hour");
}
